import Vue from 'vue'

export default Vue.extend({
    data() {
        return {
            rules: {
                required: (value: string) => !!value || this.$translator.language.data.plugins.validation.required,
                min: (value: string, size = 8) => value?.length >= size || `${this.$translator.language.data.plugins.validation.min}${size}`,

                max: (value: string, size = 255) => value.length <= size || `${this.$translator.language.data.plugins.validation.max}${size}`,

                email: (value: string) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$translator.language.data.plugins.validation.email
                }
            }
        }
    }
})
